import { render, staticRenderFns } from "./MilkVatOffsetChangeLog.vue?vue&type=template&id=6257970c&"
import script from "./MilkVatOffsetChangeLog.vue?vue&type=script&lang=ts&"
export * from "./MilkVatOffsetChangeLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports